import { Pipe, PipeTransform } from '@angular/core';
import { Conversation } from '../../models/messaging/conversation';

@Pipe({
	name: 'filterConversationBySenderIdentity'
})
export class FilterConversationBySenderIdentityPipe implements PipeTransform {
	transform(
		conversations: Conversation[],
		searchedInput: string
	): Conversation[] {
		if (!searchedInput) {
			return conversations;
		}

		// on prend en compte les mots composés (= avec espace), et on retire les accents/majuscules
		const splittedSearchedInput = searchedInput
			.split(' ')
			.map((input) => this.normalizedString(input))
			.filter((input) => input !== '');

		return conversations.filter((conversation) => {
			const employee = conversation.user.employee;
			if (employee) {
				const identity =
					this.normalizedString(employee.firstName) +
					this.normalizedString(conversation.user.employee.lastName);
				return splittedSearchedInput.some((input) => identity.includes(input));
			}
			return false;
		});
	}

	// Remove accent, transform to lower case and trim spaces
	normalizedString(word: string) {
		return word
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.toLowerCase();
	}
}
